import { useContext } from 'react';
import ServerResponseStatusContext from './ServerResponseStatusContext';

interface HttpStatusProps {
  code: number
}

export default function HttpStatus({ code }: HttpStatusProps) {
  const reportServerResponseStatus = useContext(ServerResponseStatusContext);

  reportServerResponseStatus?.(code);

  return null;
}
